import { CssBaseline, ThemeProvider as MUIThemeProvider } from '@mui/material';
import { PropsWithChildren } from 'react';
import { theme } from '../../design-system/theme';

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline>{children}</CssBaseline>
    </MUIThemeProvider>
  );
}
